import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../../contexts/auth';
import { getShifts, getRichiesteGiustificativi } from '../../services/api_dipendenti';
import { Link } from 'wouter';
import Swal from "sweetalert2";

// import checkicon
import { XCircleIcon } from '@heroicons/react/20/solid';
import CheckCircleIcon from '@heroicons/react/24/outline/esm/CheckCircleIcon';
import { ClockIcon } from "@heroicons/react/24/outline";
import Empty from '../../components/empty';

import { Popover } from '@headlessui/react';
import Fetching from "../../components/fetching";
import Modal from "../../components/modal";

import moment from "moment"
import { months } from "../../config"
import SlideOverPdf from "../../components/slide_over_pdf";
import { getWeekBoundaries } from "../../utils";
import MonthView from "../../components/areariservata/month_view";
import PopoverComponentCustom from '../../components/popover_component';


const mesiInItaliano = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function formatJustificationEnd(datetimeFrom, datetimeTo) {
    const from = moment(datetimeFrom);
    const to = moment(datetimeTo);

    // Crea una copia di 'from' per evitare di modificarlo
    const fromCopy = moment(from);

    // Verifica se il datetime_to è esattamente a mezzanotte del giorno successivo
    const isNextDayMidnight =
        to.isSame(fromCopy.add(1, 'days').startOf('day'), 'day') && to.format('HH:mm') === '00:00';
    
    // Se datetime_to è a mezzanotte del giorno successivo, mantieni la stessa data di inizio per il "giorno" di fine
    const endDate = isNextDayMidnight ? from.format('DD/MM/YYYY') : to.format('DD/MM/YYYY');
    const endTime = isNextDayMidnight ? '24:00' : to.format('HH:mm');
    
    return {
        date: endDate,
        time: endTime,
    };
}


export default function ArTurni() {
  const { token, profile } = useContext(AuthContext);

  const [docs, setDocs] = useState([]);
  const [justifications, setJustifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [day, setDay] = useState(new Date());
  const [weekInfo, setWeekInfo] = useState({});
  const [monthInfo, setMonthInfo] = useState({});
  const hasActiveContract = profile?.employee?.has_active_contract

  useEffect(() => {
    fetchData();
  }, [token]);

  const fetchData = async (realday = day) => {
    const tempDay = moment(realday);
    const startOfMonth = moment(realday).startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment(realday).endOf('month').format('YYYY-MM-DD');
    
    
    
    setWeekInfo({ startOfMonth, endOfMonth });
    setLoading(true);
    try {
      const shiftsResponse = await getShifts(token, { start: startOfMonth, end: endOfMonth });
      setDocs(shiftsResponse);
      setDay(tempDay.toDate());

      
      const justificationsResponse = await getRichiesteGiustificativi(token, {
        start_date: startOfMonth,
        end_date: endOfMonth,
      });
      setJustifications(justificationsResponse.results);
      
      setLoading(false);
    } catch (error) {
      setLoading(false);
      let errorMessage = 'Non è stato possibile aggiornare i dati. Per favore riprova.';

      if (error?.response?.data?.detail === 'Non hai i permessi per visualizzare i turni precedenti al mese corrente.') {
        Swal.fire({
          icon: 'warning',
          title: 'Accesso negato',
          text: error.response.data.detail,
          confirmButtonText: 'OK',
        });

        const today = moment();
        setDay(today.toDate());
        fetchData(today.toDate());
        return;
      }

      if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];

        Object.keys(errorData).forEach((key) => {
          const messageArray = errorData[key];
          if (Array.isArray(messageArray)) {
            errorMessages.push(...messageArray);
          } else if (typeof messageArray === 'string') {
            errorMessages.push(messageArray);
          }
        });

        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(' ');
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    }
  };

  const nextMonth = () => {
    setDay(moment(day).add(1, 'month').toDate());
    fetchData(moment(day).add(1, 'month').toDate());
  }

  const prevMonth = () => {
    setDay(moment(day).subtract(1, 'month').toDate());
    fetchData(moment(day).subtract(1, 'month').toDate());
  }

  const setOggi = () => {
    setDay(new Date());
    fetchData(new Date());
  }


  return <div>
    <PopoverComponentCustom title='I miei turni' />

    {loading && <Fetching />}

    {(!loading && (!docs || Object.keys(docs).length === 0)) && (
      <Empty />
    )}

    {!loading && !hasActiveContract && (
      <div
        className="m-4 relative block rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
      >
        <div role="status">
          <span className="sr-only">Nessun dato</span>
        </div>
        <span className="mt-2 block text-sm font-semibold text-gray-900">Non hai un contratto attivo</span>
      </div>
    )}

    {(!loading && docs.id && hasActiveContract) && (
      <div className="px-4 sm:px-6 lg:px-8 mt-5">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">Turni di {mesiInItaliano[moment(day).format('M') - 1]} {moment(day).format('YYYY') }</h1>
            <p className="mt-2 text-sm text-gray-700">
              Qui puoi vedere i tuoi turni per il mese selezionato
            </p>
            <div className="relative flex items-center rounded-md bg-white md:items-stretch mt-3">
              <button onClick={prevMonth} type="button" className="flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l border-gray-300 pr-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-gray-50">
                <span className="sr-only">Mese Precedente</span>
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd"></path>
                </svg>
              </button>
              <button onClick={setOggi}
              type="button" className="hidden border-y border-gray-300 px-3.5 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:relative md:block">{mesiInItaliano[moment(day).format('M') - 1]} {moment(day).format('YYYY') }</button>
              <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden"></span>
              <button onClick={nextMonth} type="button" className="flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r border-gray-300 pl-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-gray-50">
                <span className="sr-only">Mese Successivo</span>
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>
          <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">

          </div>
        </div>
        <div className="-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">
          <div className="overflow-x-auto">
            {/*<CalendarTable docs={docs} />*/}
            {//<MonthView day={day}/>
            }
            <Calendar data={docs} justifications={justifications} />
          </div>
        </div>
      </div>
    )}

    


  </div>
}

const Calendar = ({ data, day, justifications }) => {
  // Helper function to get the day of the week
  const getDayOfWeek = (dateString) => {
    const date = new Date(dateString);
    const days = ['Domenica', 'Lunedi', 'Martedi', 'Mercoledi', 'Giovedi', 'Venerdi', 'Sabato'];
    return days[date.getDay()];
  };

  const getJustificationsForDay = (date) => {
    return justifications.filter(j =>  moment(date).isSame(j.datetime_from, 'day') || moment(date).isBetween(j.datetime_from, j.datetime_to));
  }; 

  const showOptions = (id, show=true) => {
    const button = document.getElementById(id);
    if (button && show) {
      button.classList.remove('hidden');
    }
    if (button && !show) {
      button.classList.add('hidden');
    }
  }

  const formatDuration = (durationInMinutes) => {
    const totalHours = Math.floor(durationInMinutes / 60);
    const remainingMinutes = durationInMinutes % 60;
  
    if (totalHours > 0 && remainingMinutes > 0) {
      return `${totalHours} h, ${remainingMinutes} min`;
    } else if (totalHours > 0) {
      return `${totalHours} h`;
    } else if (remainingMinutes > 0) {
      return `${remainingMinutes} min`;
    } else {
      return `0 min`;
    }
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex flex-col">
        {data.days.map(d => (
          <div key={d.date} className="flex items-center border-b border-gray-300 py-2" 
            onMouseEnter={() => showOptions("giorno" + moment(d.date).format('DD'))}
            onMouseLeave={() => showOptions("giorno" + moment(d.date).format('DD'), false)}
            >
            <div className={"w-1/6 pe-4"}>
            {(d.holidays && d.holidays.length > 0) || getDayOfWeek(d.date) === 'Domenica' ? (
              <div>
                <div className="text-lg font-semibold text-red-600">{moment(d.date).format('DD')}</div>
                <div className="text-sm text-gray-500">{getDayOfWeek(d.date)}</div>
                {d.holidays && d.holidays.length > 0 && (
                  <div className="text-xs text-red-500 uppercase">{d.holidays[0].name}</div>
                )}
              </div>
            ) : (
              <div>
                <div className="text-lg font-semibold">{moment(d.date).format('DD')}</div>
                <div className="text-sm text-gray-500">{getDayOfWeek(d.date)}</div>
              </div>
            )}
              {
                moment(d.date).format('YYYY-MM-DD') === moment(day).format('YYYY-MM-DD') && (
                  <span className="w-full  inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10">
                    Oggi
                  </span>
                )
              }
            </div>
            <div className="w-5/6 flex flex-col">
              {d.shifts && d.shifts.length > 0 ? (
                d.shifts.map((shift, shiftIndex) =>
                  shift.time_slots && shift.time_slots.length > 0 ? (
                    shift.time_slots.map((timeSlot, timeSlotIndex) => (
                      <div
                        key={`${shiftIndex}-${timeSlotIndex}`}
                        className="flex items-center justify-between bg-gray-100 p-2 rounded mb-2"
                      >
                        <div className="text-sm">
                          <div>
                            <span className="font-semibold">Inizio:</span> {timeSlot.start_at || ""}
                          </div>
                          <div>
                            <span className="font-semibold">Fine:</span> {timeSlot.end_at || ""}
                          </div>
                        </div>
                        <div className="text-sm">
                          {timeSlot.breaks && timeSlot.breaks.length > 0 ? (
                            timeSlot.breaks.map((b, breakIndex) => (
                              <div key={breakIndex}>
                                <span className="font-semibold">Pausa:</span> {b.start_at || ''} -{" "}
                                {b.end_at || ''}
                              </div>
                            ))
                          ) : (
                            <div>Nessuna pausa</div>
                          )}
                        </div>
                        <div className="text-sm">
                          <span className="font-semibold">Durata:</span> {formatDuration(timeSlot.duration) || ''}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div key={shiftIndex} className="text-sm text-gray-500 pb-2">Nessun turno previsto</div>
                  )
                )
              ) : (
                <div className="text-sm text-gray-500 pb-2">Nessun turno previsto</div>
              )}
              {getJustificationsForDay(d.date)
                .filter(justification => justification.status === 'approved' || justification.status === null)
                .sort((a, b) => new Date(a.datetime_from) - new Date(b.datetime_from))
                .map(justification => {
                  const startDate = moment(justification.datetime_from);
                  const { date: formattedEndDate, time: formattedEndTime } = formatJustificationEnd(justification.datetime_from, justification.datetime_to);
                  const isSameDay = startDate.format('DD/MM/YYYY') === formattedEndDate;
                  const isFullDay = startDate.format('HH:mm:ss') === '00:00:00' && moment(justification.datetime_to).format('HH:mm:ss') === '23:59:59';

                  return (
                    <div key={justification.id} className="text-sm">
                      {justification.status === 'approved' ? (
                        <div className="w-full mb-1 inline-flex items-center rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10">
                          <CheckCircleIcon className="h-4 w-4 inline-block me-1" />
                          <span className="font-semibold">{justification.justification.justification.description}</span>
                          {isFullDay ? (
                            <span>, intera giornata</span>
                          ) : isSameDay ? (
                            <>
                              <span className="pl-1"></span>dalle ore {startDate.format('HH:mm')} 
                              alle ore {formattedEndTime}
                            </>
                          ) : (
                            <>
                              <span className="pl-1"></span>dalle ore {startDate.format('HH:mm')} del {startDate.format('DD/MM')} 
                              alle ore {formattedEndTime} del {formattedEndDate}
                            </>
                          )}
                          <span className="font-semibold ml-1"> - Approvato</span>
                        </div>
                      ) : (
                        <div className="w-full mb-1 inline-flex items-center rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-gray-700 ring-1 ring-inset ring-orange-700/10">
                          <ClockIcon className="h-4 w-4 inline-block me-1" />
                          <span>Richiesta in attesa di esito: {justification.justification.justification.description}</span>
                          {isFullDay ? (
                            <span>, intera giornata</span>
                          ) : isSameDay ? (
                            <>
                              <span className="px-1">dalle ore {startDate.format('HH:mm')}</span> 
                               alle ore {formattedEndTime}
                            </>
                          ) : (
                            <>
                              <span className="pl-1"></span>dalle ore {startDate.format('HH:mm')} del {startDate.format('DD/MM')} 
                               alle ore {formattedEndTime} del {formattedEndDate}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}

              <Link
                to={`/areariservata/richiesta?day=${moment(d.date).format('DD/MM/YYYY')}&showForm=true`}
                id={`giorno${moment(d.date).format('DD')}`}
                className="richiedi-giustificativo hidden group-hover:block rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 mt-2"
              >
                Richiedi Giustificativo
              </Link>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// const CalendarTable = ({ docs }) => {
//   const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

//   return (
//     <div className="overflow-x-auto">
//       <table className="min-w-full bg-white">
//         <thead>
//           <tr>
//             {docs.days.map((day, index) => (
//               <th key={index} className="py-2 px-4 bg-gray-200 font-bold uppercase text-sm text-gray-600">
//                 {daysOfWeek[new Date(day.date).getDay()]}<br />{day.date}
//               </th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           <tr>
//             {docs.days.map((day, index) => (
//               <td key={index} className="py-2 px-4 border-b align-top">
//                 <div>Typology: {day.typology || 'N/A'}</div>
//                 <div>Ref ID: {day.ref_id || 'N/A'}</div>
//                 <div>Daily Working Hour: {day.daily_working_hour || 'N/A'}</div>
//                 {day.time_slots.length === 0 ? (
//                   <div className="py-2 px-4">No time slots</div>
//                 ) : (
//                   day.time_slots.map(slot => (
//                     <div key={slot.id} className="mt-2">
//                       <div>Start: {slot.start_at}</div>
//                       <div>End: {slot.end_at}</div>
//                       <div>Breaks:
//                         {slot.breaks.map(breakSlot => (
//                           <div key={breakSlot.id} className="ml-2">
//                             <div>Start: {breakSlot.start_at}</div>
//                             <div>End: {breakSlot.end_at}</div>
//                           </div>
//                         ))}
//                       </div>
//                       <div>Duration: {slot.duration} mins</div>
//                     </div>
//                   ))
//                 )}
//               </td>
//             ))}
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };
